<style lang="scss">
.ivu-select-input, .ivu-select-input[disabled]{
    color:#333 !important;
    -webkit-text-fill-color: #333 !important;
}
</style>

<template>
    <div class="lookinfo">
        <Breadcrumb class="tablelist-header">
            <BreadcrumbItem to="/">{{type==='edit'?$t('global.common.operation_edit', { defaultValue: '编辑' }):$t('erp.product.new_add', { defaultValue: '添加' })}}{{$t('erp.b2c.channel_warehouse', { defaultValue: '渠道仓库' })}}</BreadcrumbItem>
        </Breadcrumb>
        <Alert  class="padding-10" show-icon v-html="$t('erp.channel.operation_alert')"></Alert>
        <div class="bg-fff padding-bottom-10 shadow">
            <header class="detail-title">{{$t('global.common.base_information', { defaultValue: '基本信息' })}}</header>
            <Form :label-width="160" ref="form" :model="otherData">
                <FormItem prop='channelCategoryId' :label="$t('erp.channelbase.channel_type', { defaultValue: '渠道类型' })" class="width-50per" :rules="required">
                    <!-- <span v-if="isEdit"  class="item-content">{{formData.channelCategoryId|transferText('name',accountTypes,'id')}}</span> -->
                    <Select v-model="otherData.channelCategoryId" filterable :disabled="isEdit">
                        <Option v-for="item in accountTypes" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>
                <div :key="otherData.channelCategoryId" :class="isEdit?'splitline margin-bottom-15':null">
                    <FormItem prop='accountId' :label="$t('erp.channelbase.channel_name', { defaultValue: '渠道名称' })" class="width-50per" :rules="required" >
                        <!-- <span v-if="isEdit"  class="item-content">{{formData.accountId|transferText('title',accounts,'channelCategoryId')}}</span> -->
                        <Select  v-model="otherData.accountId" filterable :disabled="isEdit">
                            <Option v-for="item in accountsTarget" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                </div>
            </Form>
            <Form
            :label-width="160"
            v-for="(item,index) in formData"
            :key="index"
            :ref="'form'+index"
            :model="formData[index]"
            class="splitline margin-bottom-10">
                <FormItem prop='addressCode' :label="$t('erp.channel.warehouse_sign', { defaultValue: '渠道仓库标识符' })" class="width-50per" :rules="required">
                    <Input v-model.trim="item.addressCode" class="width-100per" />
                </FormItem>
                <FormItem prop='orgWarehouseId' :label="$t('erp.b2c.product_orgwarehouse', { defaultValue: '仓库' })" class="width-50per" :rules="required">
                    <Select v-model="item.orgWarehouseId" filterable>
                        <Option v-for="item in warehousesTarget" :value="item.value" :key="item.value" :disabled='item.disabled'>{{ item.label }}</Option>
                    </Select>
                </FormItem>
               <footer  class="text-right padding-10">
                    <Button type="error" class="width-15per" @click="deleteData(index)" >{{$t('erp.channel.delete_record', { defaultValue: '删除记录' })}}</Button>
               </footer>
            </Form>
            <footer class="text-right  padding-right-10" v-if="type==='edit'" >
                <Button type="info" @click="nextAdd" class="width-15per">{{$t('erp.channel.add_warehouse_continue', { defaultValue: '继续添加渠道仓库' })}}</Button>
                <Button type="primary" @click="submit" class="width-15per">{{$t('erp.channel.change_save', { defaultValue: '修改保存' })}}</Button>
                <Button class="width-15per" @click="cancel">{{$t('global.common.return', { defaultValue: '返回' })}}</Button>
            </footer>
            <footer class="text-right  padding-right-10" v-else>
                <Button type="info" @click="nextAdd" class="width-15per">{{$t('erp.channel.add_warehouse_continue', { defaultValue: '继续添加渠道仓库' })}}</Button>
                <Button type="primary" @click="submit" class="width-15per">{{$t('global.common.save', { defaultValue: '保存' })}}</Button>
                <Button class="width-15per" @click="cancel">{{$t('global.common.return', { defaultValue: '返回' })}}</Button>
            </footer>
        </div>
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { HttpUpdateWhAccount, HttpWhAccount, HttpAccountType } from '@/service/boss/allot';

export default {
    data() {
        return {
            loading: false,
            type: this.$route.params.type,
            id: this.$route.query.id,
            isEdit: false,
            accountTypes: [],
            otherData: {
                accountId: '',
                channelCategoryId: ''
            },
            formData: [{
                addressCode: '',
                orgWarehouseIds: '',
            }],
            required: [{
                required: true,
                message: this.$t('global.common.required', { defaultValue: "该信息不能为空,请填写" })
            }],
        }
    },
    mounted() {
        this.isEdit = this.type === 'edit';
        this.gtAccountTypes();
        this.getDetail();
        
    },
    destroyed() {
        sessionStorage.set('accountJson', '')
    },
    computed: {
        ...mapGetters('diction',['getNewAccountIdList','getNewWarehouseIdList']),
        warehouses(){
            return this.getNewWarehouseIdList.filter(item => {
                return item.attach.item.warehouseType !== 2 && item.attach.item.warehouseType !== 4;
            });
        },
        accountsTarget() {
            const id = this.otherData.channelCategoryId;
            // this.otherData.accountId = '';
            return this.getNewAccountIdList.filter((item) => {
                return item.attach.item.channelCategoryId == id;
            })
        },
        warehousesTarget() {
            const orgWarehouseIds = [];
            this.formData.forEach((item) => {
                let ids = item.orgWarehouseIds || [];
                orgWarehouseIds.push(...item.orgWarehouseIds);
            });
            return this.warehouses.map((item) => {
                if (orgWarehouseIds.indexOf(item.id) > -1) {
                    item.disabled = true;
                } else {
                    item.disabled = false;
                }
                return item;
            })
        },

    },
    methods: {
        cancel() {
            this.$router.push({ name: 'whAccountlist' })
        },
        deleteData(index) {
            if (this.formData.length <= 1) {
                this.$Message.warning(this.$t('erp.channel.not_allow_delete', { defaultValue: '不允许删除，至少有一条数据' }));
                return;
            }
            this.formData.splice(index, 1);
        },
        nextAdd() {
            this.formData.push({
                addressCode: '',
                orgWarehouseIds: '',
            });
        },
        handleRequest() {
            // console.log(this.formData,'this.formData')
            const data = {
                type: this.type === 'edit' ? 1 : 0,
                orgId: global.SYSID,
                ...this.otherData,
                channelCategory: (this.accountTypes.filter((item) => {
                    return this.otherData.channelCategoryId == item.id;
                })[0] || {}).name,
                accountFlag: (this.accountsTarget.filter((item) => {
                    return this.otherData.accountId == item.value;
                })[0] || {}).attach.item.flag,
                addressList: this.formData.map((item) => {
                    // console.log(item,'34534534534534')
                    const ids = item.ids || {};
                    const wareid = item.orgWarehouseId;
                    let orgWarehouseCode = (this.warehousesTarget.filter((item) => {
                        return item.value == wareid
                    })[0] || {}).attach.item.code;
                    if(this.type === 'edit'){
                        return {
                            id: item.id,
                            addressCode: item.addressCode,
                            // items: item.orgWarehouseIds.map((val) => {
                            //     console.log(val,'vaval')
                            //     const id = ids[val],
                            //         orgWarehouseCode = (this.warehousesTarget.filter((item) => {
                            //             // return item.value == val
                            //             return item.value == wareid
                            //         })[0] || {}).attach.item.code;
                            //     return {
                            //         id,
                            //         orgWarehouseId: wareid,
                            //         orgWarehouseCode
                            //     } 
                            // })
                            items:[{
                                    id:ids[0],
                                    orgWarehouseId: wareid,
                                    orgWarehouseCode
                                } ]
                        }
                    }else{
                        return {
                            id: item.id,
                            addressCode: item.addressCode,
                            items: [{
                                orgWarehouseId: wareid,
                                orgWarehouseCode
                            }]
                        }
                    }
                }),
            }
            return data;
        },
        handleDResponse(data) {
            const firstItem = data[0];
            if (!firstItem) return;
            this.formData = data.map((item) => {
                const ids = {},//编辑内部的映射id
                    orgWarehouseIds = item.items.map((json) => {
                        ids[json.orgWarehouseId] = json.id;
                        return json.orgWarehouseId;
                    });
                return {
                    id: item.id,
                    addressCode: item.addressCode,
                    orgWarehouseId:item.items[0].orgWarehouseId,
                    orgWarehouseIds,
                    ids
                }
            });
            this.otherData.channelCategoryId = firstItem.channelCategoryId;
            setTimeout(() => {
                this.$set(this.otherData, 'accountId', firstItem.accountId)
            }, 300)
        },
        async gtAccountTypes() {
            HttpAccountType().then(res => {
                this.accountTypes = res.data;
            }, err => {
                this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
            })
        },
        async getDetail() {
            if (this.type !== 'edit'){
                
                var json = sessionStorage.get('accountJson')
                if(json!=''){
                    var item =  JSON.parse(json)
                    // this.otherData.accountId = item.accountId
                    this.otherData.channelCategoryId = item.channelCategoryId
                    this.$set(this.otherData, 'accountId', item.accountId)
                    // console.log(this.otherData.accountId)
                }
                return false;
            } 
            // console.log(123123213)
            this.loading = true;
            HttpWhAccount({ accountId: this.id }).then(res => {
                this.handleDResponse(res.data);
                this.loading = false;
            }, err => {
                this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
                this.loading = false;
            })
        },
        async submit() {
            let valid = [await this.$refs['form'].validate()];
            for (let i = 0, len = this.formData.length; i < len; i++) {
                valid.push(await this.$refs['form' + i][0].validate());
            }
            valid = valid.every(item => item);
            if (!valid) return;
            this.loading = true;
            HttpUpdateWhAccount(this.handleRequest()).then(res => {
                this.$Message.success(res.message);
                this.$router.push({ name: "whAccountlist" });
                this.loading = false;
            }, err => {
                this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
                this.loading = false;
            })
        }
    }
}
</script>

